import { api } from '~config/api';

import PollingService from '../PollingService';

import { getJobShow, INTERVAL, TIMEOUT } from './utils';

export const OrderService = {
  getOrders: ({ status, filters = '', page = 1, cancelToken }) =>
    api.get(`v1/kds/rejected_orders?pos_status=${status}&page=${page}${filters}`, null, {
      cancelToken
    }),
  assignOrder: ({ id }) => api.patch(`v1/kds/rejected_orders/${id}/assign_user`),
  injectOrder: ({ id, fbdId }) =>
    api.patch(`v1/kds/rejected_orders/${id}/assign_external_id`, {
      order: { fbdId }
    }),
  downloadRejectedOrders: ({ filters = '' }) =>
    PollingService.poll(
      api.post(`v1/kds/rejected_orders/export_csv?pos_status=pos_manually_loaded,pos_failed${filters}`),
      getJobShow,
      INTERVAL,
      TIMEOUT
    )
};

export default OrderService;
